import * as Logger from "js-logger";
import { Exit } from "slotworks/state-machine/data/exit";
import Link from "slotworks/state-machine/data/link";
import Decision from "slotworks/state-machine/decisions/decision";
import State from "slotworks/state-machine/states/state";
import SuperState from "slotworks/state-machine/states/superstate";

export default class Node {

    public name: string;
    public concrete: State | Decision | SuperState;
    public params: object;
    public turboSkip: boolean;
    public cascadeSkip: boolean;
    public entrySubState: Node;
    private exits: Map<string | Exit, Link>;

    constructor(name: string, concrete: State | Decision | SuperState, params?: object, cascadeSkip: boolean = false, turboSkip: boolean = false, entrySubState?: Node) {

        this.name = name;
        this.cascadeSkip = cascadeSkip;
        this.turboSkip = turboSkip;
        this.entrySubState = entrySubState;

        if (concrete instanceof SuperState && !entrySubState) {
            throw new Error("Node :: Attempted to create super state node without an entry sub state");
        }

        this.concrete = concrete;
        if (!(this.concrete instanceof Decision) && params) {
            this.concrete.params = params;
        }

        this.exits = new Map<string | Exit, Link>();
    }

    public getLink(exit: string | Exit): Link {

        if (!this.exits.has(exit)) {
            if (exit === Exit.Skip) {
                Logger.warn("Link out of " + this.name + " with exit Skip not found. Falling back to Complete");
                return this.getLink(Exit.Complete);
            } else {
                throw new Error("Cannot find link out of " + this.name + " with exit " + exit);
            }
        }

        return this.exits.get(exit);
    }

    public addLink(exit: string | Exit, target: string | Node) {
        this.exits.set(exit, new Link(target));
    }
}
